import {
    axios
} from '@/utils/request'

const list = (parameter) => {
    return axios({
        url: '/user/list',
        method: 'post',
        data: parameter
    })
}
const roleList = (parameter) => {
    return axios({
        url: '/role/list',
        method: 'post',
        data: parameter
    })
}
const add = (parameter) => {
    return axios({
        url: '/user',
        method: 'post',
        data: parameter
    })
}
const update = (parameter) => {
    return axios({
        url: '/user',
        method: 'PUT',
        data: parameter
    })
}
const del = (parameter) => {
    return axios({
        url: '/user',
        method: 'delete',
        params: parameter
    })
}
const detail = (parameter) => {
    return axios({
        url: '/user',
        method: 'get',
        params: parameter
    })
}
export {
    list,
    roleList,
    add,
    update,
    del,
    detail,
}
